module.exports = __webpack_public_path__ + "static/Heartland Payment Systems-6e4718a4bfb292f35d4f5d035e8c9abe.svg";